import createAxiosInstance from "../../utils/axiosInstance";

export const getAllReminders = async ({ host, accessToken, uuid, startDate, endDate}) => {
    const url = `${host}api/v1/reminders?limit=31&page=1&us_uuid=${uuid}&start_date=${startDate}&end_date=${endDate}`;
    try {
        const axiosInstance = createAxiosInstance(accessToken, url);
        const response = await axiosInstance.get();
        return response.data;
    } catch (error) {
        console.error('Error fetching reminders:', error);
        throw error;
    }
}
